<div class="dropdown">
  <div class="dropdown-header flex items-center justify-between">
    <div>
      <div class="dropdown-heading">Notificaciones</div>
      <div class="dropdown-subheading">
        Tienes {{ notifications.length }} notificaciones.
      </div>
    </div>

  </div>

  <div class="dropdown-content">
    <a
      *ngFor="let notification of notifications; trackBy: trackById"
      [class.read]="notification.leida"
      class="notification flex items-center"
      (click)="markAsRead(notification.id)"
      matRipple>
      <mat-icon
      [ngClass]="notification.colorClass"
      [svgIcon]="notification.icon"


        class="notification-icon flex-none"></mat-icon>
      <div class="flex-auto">
        <div class="notification-label">{{ notification.descripcion }}</div>
        <div class="notification-description">
          {{ notification.fecha_hora }}
        </div>
      </div>
    </a>
  </div>

  <div class="dropdown-footer flex items-center justify-center">
    <button mat-button (click)="markAllAsRead()">Marcar todas como leídas</button>
  </div>
</div>

